<ui-modal
  uiModalPortal
  [isOpen]="isOpen"
  size="medium"
  [growVertically]="false"
  [disableOverlayClose]="true"
  position="center"
  (onClose)="close()"
  (isOpenChange)="isOpenChange.emit($event)"
>
  <div class="file-delete-modal">
    <div class="file-delete-modal__header">
      <h3 class="file-delete-modal__title">{{ "message.Are_you_sure" | translate }}</h3>
    </div>
    <div class="file-delete-modal__body">
      <p class="file-delete-modal__message">{{ fileName }}</p>
    </div>
    <div class="file-delete-modal__actions">
      <ui-button
        variant="destructive"
        size="large"
        [fullWidth]="true"
        [disabled]="submitting"
        [label]="'uploads.Delete_file' | translate"
        (clicked)="confirm()"
      ></ui-button>
      <ui-button
        variant="tertiary"
        size="large"
        [fullWidth]="true"
        [disabled]="submitting"
        [label]="'settings.Cancel' | translate"
        (clicked)="close()"
      ></ui-button>
    </div>
  </div>
</ui-modal>
